import React from "react";
import SidebarItem from "./SidebarItem";
import { SidebarItemData } from "../../Data/data";

export default function Sidebar() {
  return (
    <div className="shadow-lg shadow-gray-300 rounded-2xl p-4 border border-gray-300 text-left flex flex-col gap-4 h-fit">
      <h3 className=" text-xl font-bold">Why SCS education</h3>
      <div className="flex flex-col gap-4">
        {SidebarItemData.map((item) => (
          <SidebarItem key={item.title} {...item} />
        ))}
      </div>
    </div>
  );
}
